module.exports = __webpack_public_path__ + "static/w-hani-8fe1fd0d02892f308591a7afb1650b8f.jpg";